"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageLayer = void 0;
const UserInfo_service_1 = require("./UserInfo.service");
const Crm_service_1 = require("./Crm.service");
const TpdAgency_service_1 = require("./TpdAgency.service");
const TpdTelematics_service_1 = require("./TpdTelematics.service");
const TpdContratti_service_1 = require("./TpdContratti.service");
const Liquido_service_1 = require("./Liquido.service");
const LoyaltyLite_service_1 = require("./LoyaltyLite.service");
const constants_1 = require("../common/constants");
const network_config_1 = require("../common/network.config");
// import { HttpErrorResponse } from "@angular/common/http";
const TpdContestoUtente_service_1 = require("./TpdContestoUtente.service");
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const common_functions_1 = require("../common/common-functions");
const Encryption_service_1 = require("./Encryption.service");
class LocalStorageLayer {
    constructor() {
        // ABILITA/DISABILITA L'USO DEL LOCALSTORAGE / SERVIZIO DI CRIPTAZIONE / ERROR COLLECTOR / CHIAMATE A SERVIZI TELEMATICI
        this.isLocalStorageEnabled = true;
        this.encryptionServiceEnabled = true;
        this.isErrorCollectorEnabled = false;
        this.isTelematicsAble = true;
        this.arrayConstructor = [].constructor;
        if (!this.isLocalStorageEnabled) {
            console.warn("[WARNING] LOCAL STORAGE LAYER DISABLED !!!!!!!");
        }
        if (!this.encryptionServiceEnabled) {
            console.warn("[WARNING] ENCRYPTION SERVICE DISABLED !!!!!!!");
        }
        if (!this.isErrorCollectorEnabled) {
            // console.warn("[WARNING] ERROR COLLECTOR DISABLED !!!!!!!");
        }
        if (!this.isTelematicsAble) {
            console.warn("[WARNING] TELEMATICS SERVICES DISABLED !!!!!!!");
        }
    }
    // ------------------------------------FUNZIONI ESPOSTE DAL SERVIZIO------------------------------------//
    // SE TROVO I DATI NEL LOCALSTORAGE, LI DECRIPTO E LI USO
    dataFromStorage(keyItem, notEncrypted, options) {
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(keyItem)
                .then((val) => __awaiter(this, void 0, void 0, function* () {
                if (!val) {
                    return Promise.resolve(null);
                }
                let parsed;
                if (notEncrypted) {
                    parsed = parse(val);
                }
                else {
                    if (this.encryptionServiceEnabled) {
                        const toParse = yield Encryption_service_1.EncryptionService.decrypt(keyItem);
                        parsed = parse(toParse);
                    }
                    else {
                        parsed = parse(val);
                    }
                }
                if (typeof location === "object") {
                    const ttl = location.href.indexOf(`svil.${nodejs_library_1.Helpers.BrandNameHelper.urlName()}.it`) > -1 ||
                        location.href.indexOf(`coll.${nodejs_library_1.Helpers.BrandNameHelper.urlName()}.it`) > -1 ||
                        location.href.indexOf(`inte.${nodejs_library_1.Helpers.BrandNameHelper.urlName()}.it`) > -1
                        ? constants_1.Constants.shortTtlSessionStorage
                        : constants_1.Constants.ttlSessionStorage;
                    if (parsed && parsed.ts) {
                        if (new Date().getTime() - parsed.ts < ttl) {
                            return Promise.resolve(parsed.response);
                        }
                        else {
                            return Promise.resolve(null);
                        }
                    }
                    else {
                        return Promise.resolve(parsed);
                    }
                }
                return Promise.resolve(null);
            }))
                .catch(() => Promise.resolve(null))
            : Promise.resolve(null);
        function parse(str) {
            if (options && options.notParse) {
                return str;
            }
            return JSON.parse(str);
        }
    }
    // Questo metodo è usato solo nel getData1 con verifica della cache temporizzata
    data1FromStorage(keyItem) {
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(keyItem).then((val) => __awaiter(this, void 0, void 0, function* () {
                if (!val) {
                    return Promise.resolve(null);
                }
                let parsed;
                if (this.encryptionServiceEnabled) {
                    const toParse = yield Encryption_service_1.EncryptionService.decrypt(keyItem);
                    parsed = parse(toParse);
                }
                else {
                    parsed = parse(val);
                }
                if (typeof location === "object") {
                    return Promise.resolve(parsed);
                }
                return Promise.resolve(null);
            }))
            : Promise.resolve(null);
        function parse(str) {
            return JSON.parse(str);
        }
    }
    // RESTITUISCE L'ELENCO DELLE AGENZIE A CUI L'UTENTE È ABILITATO
    getData0() {
        const id = constants_1.Constants.lsMapObject._data0;
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(id)
                .then((vl) => {
                if (vl && this.isLocalStorageEnabled) {
                    return this.dataFromStorage(id);
                }
                else {
                    return this.setData0(id);
                }
            })
                .catch(() => this.setData0(id))
            : Promise.resolve(null);
    }
    // RESTITUISCE getUserCtx()
    getData1(fromTelematicHomepage, login) {
        return __awaiter(this, void 0, void 0, function* () {
            if (nodejs_library_1.Helpers.EnvironmentHelper.isClientSide() &&
                (yield common_functions_1.CommonFunctions.isUserLogged()) &&
                location.href.indexOf("logout") === -1) {
                console.log("user is not logged in");
                const id = constants_1.Constants.lsMapObject._data1;
                return nodejs_library_1.Helpers.SessionHelper.getData(id)
                    .then((val) => {
                    if (val && this.isLocalStorageEnabled) {
                        return this.data1FromStorage(id);
                    }
                    else {
                        return this.setData1UCC(id, fromTelematicHomepage, login);
                    }
                })
                    .catch(() => Promise.resolve(null));
            }
            else {
                console.log("user is not logged in");
                return Promise.resolve(null);
            }
        });
    }
    // RESTITUISCE getVASInformations()
    getData2(plate) {
        const id = constants_1.Constants.lsMapObject._data2;
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(id)
                .then((val) => {
                if (val && this.isLocalStorageEnabled) {
                    return this.dataFromStorage(id);
                }
                else {
                    return this.setData2(id, plate);
                }
            })
                .catch(() => this.setData2(id, plate))
            : Promise.resolve(null);
    }
    // tslint:disable: jsdoc-format
    // RESTITUISCE LE SCELTE DELL'UTENTE
    /**
       * Il metodo permette di restituire le scelte dell'utente effettuate in navigazione
       * Accetta in ingresso un typeOfSelection numerico, i parametri da salvare sotto forma di array
       * Questa è la mappatura per il case selezionato in base al parametro "typeOfSelection"
       * @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
       * case 1: //VADO IN DETTAGLIO POLIZZA DA HOMEPAGE
          case 2: //VADO IN UNIBOX DA DETTAGLIO POLIZZA
          case 3: //VADO IN UNIBOX SELEZIONANDO UN SERVIZIO TELEMATIC
          case 4: //VADO IN UNIBOX DALLA SELEZIONE VISUALIZZA DETTAGLI oppure SALVO LA TARGA PER ASSISTENZA PAS
          case 5: //UTILIZZO LA FUNZIONE RICARICA CREDITI IN BODYGUARD O INFOVIAGGIO
          case 6: //NAVIGAZIONE PREAPERTURA DENUNCIA
          case 7: //PASSAGGIO A UNIBOX CASA-COMMERCIO/IMPRESA-SERVIZI DA HOMEPAGE E DA DETTAGLIO POLIZZA
          case 8: //DA HOMEPAGE A PAGINA INSERIMENTO PIN
          case 9: //DATI PER RICHIESTA PAS
          case 10: //DATI PER LOYALTY
          case 11: //URL TO LOGIN (OMNIBUS)
          @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
       */
    // tslint:enable: jsdoc-format
    getData3(typeOfSelection, parameters) {
        const id = constants_1.Constants.lsMapObject._data3;
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(id)
                .then((val) => {
                if (val && this.isLocalStorageEnabled) {
                    return this.dataFromStorage(id);
                }
                else {
                    if (typeOfSelection &&
                        parameters &&
                        parameters != null &&
                        parameters.length > 0) {
                        return this.setData3(id, typeOfSelection, parameters);
                    }
                    else {
                        return Promise.resolve(null);
                    }
                }
            })
                .catch(() => {
                if (typeOfSelection &&
                    parameters &&
                    parameters != null &&
                    parameters.length > 0) {
                    return this.setData3(id, typeOfSelection, parameters);
                }
                else {
                    return Promise.resolve(null);
                }
            })
            : Promise.resolve(null);
    }
    // GESTIONE UTENTE PROSPECT
    /**
     * Se chiamo questo metodo passandogli il CF, solo in fase di registrazione,
     * vado direttamente sul servizio BFF infoCliente, servizio pubblico che restituisce le info del prospect in fase di registrazione
     * Se invece lo chiamo senza il CF, questo servizio recupera le informazioni del cliente da CRM, quindi dev'essere effettuata
     * in tutte le altre parti. Il getProspect salva i dati nel localStorage, ma i dati che devono essere salvati sono solo quelli del servizio
     * CRM myCustomerInfo, NON quelli del servizio infoCliente.
     * @param "cf" : string;
     * @param "isFaseRegistrazione" : Boolean;
     * @return responseProspect contenente le informazioni del cliente, contiene la risposta del servizio myCustomerInfo;
     */
    getProspect(cf, isFaseRegistrazione, xToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const id = constants_1.Constants.lsMapObject._data8;
                if (nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()) {
                    const storageVal = yield nodejs_library_1.Helpers.SessionHelper.getData(id);
                    if (storageVal && this.isLocalStorageEnabled) {
                        return this.dataFromStorage(id);
                    }
                    else {
                        if (cf)
                            return this.setProspect(id, cf, isFaseRegistrazione, xToken);
                        else
                            return this.setProspect(id, undefined, undefined, xToken);
                    }
                }
                else {
                    return null;
                }
            }
            catch (e) {
                console.error("Errore recupero prospect", String(e));
                return null;
            }
        });
    }
    setProspect(id, cf, isFaseRegistrazione, xToken) {
        return new Promise((resolve, reject) => {
            const crmService = new Crm_service_1.CrmService();
            crmService
                .validaDatiUtente(cf, xToken)
                .then((responseProspect) => {
                var _a;
                // tslint:disable-next-line: triple-equals
                // SE NON SEI IN FASE DI REGISTRAZIONE, SALVO LA CHIAMATA DELLA myCustomerInfo
                if (!isFaseRegistrazione) {
                    this.saveData(id, responseProspect === null || responseProspect === void 0 ? void 0 : responseProspect.customerInfo);
                }
                resolve((_a = responseProspect === null || responseProspect === void 0 ? void 0 : responseProspect.customerInfo) !== null && _a !== void 0 ? _a : null);
            })
                .catch((error) => {
                console.warn(error);
                // SE RITORNO -1 SIGNIFICA CHE SI È SPACCATO IL SERVIZIO DEL PROSPECT E IN FASE DI LOGIN FACCIO IL LOGOUT
                reject(error);
            });
        });
    }
    // tslint:disable: jsdoc-format
    // tslint:disable: no-redundant-jsdoc
    /**
     *
     * @param section
     * @param param
     * @return {Promise<any>}
     */
    // tslint:enable: no-redundant-jsdoc
    // tslint:enable: jsdoc-format
    getData7(section, param) {
        const id = constants_1.Constants.lsMapObject._data7;
        return new Promise((resolve) => {
            this.dataFromStorage(id)
                .then((data) => {
                if (data) {
                    if (section) {
                        if (param) {
                            resolve(data[section] ? data[section][param] : null);
                        }
                        else {
                            resolve(data[section]);
                        }
                    }
                    else {
                        resolve(data);
                    }
                }
                else {
                    resolve({});
                }
            })
                .catch((err) => console.error(err));
        });
    }
    getData9() {
        const id = constants_1.Constants.lsMapObject._data9;
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(id)
                .then((val) => {
                if (val && this.isLocalStorageEnabled) {
                    return this.dataFromStorage(id, true);
                }
                else {
                    return Promise.reject(`No local storage enabled`);
                }
            })
                .catch(() => Promise.reject(`No local storage enabled`))
            : Promise.resolve(null);
    }
    setData9(value) {
        const id = constants_1.Constants.lsMapObject._data9;
        console.log("set data 9", value);
        return new Promise((res, rej) => {
            this.saveData(id, value, true);
            console.log("resolving promise");
            res();
        });
    }
    deleteData9() {
        const id = constants_1.Constants.lsMapObject._data9;
        return new Promise((res, rej) => {
            try {
                if (typeof window === "object") {
                    window.localStorage.removeItem(id);
                }
                res(null);
            }
            catch (err) {
                rej(err);
            }
        });
    }
    /**
     *
     * @param section
     * @param param
     * @param newData
     * @return {Promise<any>}
     */
    setData7(section, param, newData) {
        const id = constants_1.Constants.lsMapObject._data7;
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(id)
                .then((val) => {
                if (val && this.isLocalStorageEnabled) {
                    return new Promise((resolve) => {
                        this.dataFromStorage(id)
                            .then((data) => {
                            if (data) {
                                if (section) {
                                    if (param) {
                                        data[section] = data[section] || {};
                                        data[section][param] = newData;
                                    }
                                    else {
                                        data[section] = newData;
                                    }
                                }
                                else {
                                    data = newData;
                                }
                            }
                            else {
                                data = newData;
                            }
                            this.saveData(id, data);
                            resolve(newData);
                        })
                            .catch((err) => console.error(err));
                    });
                }
                else {
                    return new Promise((resolve) => {
                        const data = {};
                        if (param) {
                            data[section] = {};
                            data[section][param] = newData;
                        }
                        else {
                            data[section] = newData;
                        }
                        this.saveData(id, data);
                        resolve(newData);
                    });
                }
            })
                .catch(() => {
                return new Promise((resolve) => {
                    const data = {};
                    if (param) {
                        data[section] = {};
                        data[section][param] = newData;
                    }
                    else {
                        data[section] = newData;
                    }
                    this.saveData(id, data);
                    resolve(newData);
                });
            })
            : Promise.resolve(null);
    }
    /**
     *
     * @param section
     * @param param
     * @return {Promise<any>}
     */
    deleteData7(section, param) {
        const id = constants_1.Constants.lsMapObject._data7;
        return new Promise((resolve) => {
            if (section) {
                this.getData7()
                    .then((data) => {
                    if (param) {
                        delete data[section][param];
                    }
                    else {
                        delete data[section];
                    }
                    this.setData7(null, null, data)
                        .then((res) => {
                        resolve({ message: "ok" });
                    })
                        .catch((err) => console.error(err));
                })
                    .catch((err) => console.error(err));
            }
            else {
                // if (this.check(id)) {
                localStorage.removeItem(id);
                // }
                resolve({ message: "ok" });
            }
        });
    }
    deleteData10() {
        const id = constants_1.Constants.lsMapObject._data10;
        return new Promise((resolve) => {
            // if (this.check(id)) {
            localStorage.removeItem(id);
            // }
            resolve({ message: "ok" });
        });
    }
    // RESTITUISCE LA USERNAME PER VERIFICARE IL TOKEN DI WAITPG
    getData6() {
        const id = constants_1.Constants.lsMapObject._data6;
        return this.dataFromStorage(id);
    }
    // RESTITUISCE getOfferte()
    getData11(numQuote, numPrev, num) {
        const id = constants_1.Constants.lsMapObject._data11;
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(id)
                .then((val) => {
                if (val && this.isLocalStorageEnabled) {
                    return this.dataFromStorage(id).then((data) => {
                        if (data) {
                            return data;
                        }
                        else {
                            return this.setData11(id, numQuote, numPrev, num);
                        }
                    });
                }
                else {
                    return this.setData11(id, numQuote, numPrev, num);
                }
            })
                .catch(() => this.setData11(id, numQuote, numPrev, num))
            : Promise.resolve(null);
    }
    // RESTITUISCE getClaimsList()
    getData12() {
        const id = constants_1.Constants.lsMapObject._data12;
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(id)
                .then((val) => {
                if (val && this.isLocalStorageEnabled) {
                    return this.dataFromStorage(id).then((data) => {
                        if (data) {
                            return data;
                        }
                        else {
                            return this.setData12(id);
                        }
                    });
                }
                else {
                    return this.setData12(id);
                }
            })
                .catch(() => this.setData12(id))
            : Promise.resolve(null);
    }
    // RESTITUISCE getClaimsList()
    getData13() {
        const id = constants_1.Constants.lsMapObject._data13;
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(id)
                .then((val) => {
                if (val && this.isLocalStorageEnabled) {
                    return this.dataFromStorage(id).then((data) => {
                        if (data) {
                            return data;
                        }
                        else {
                            return this.setData13(id);
                        }
                    });
                }
                else {
                    return this.setData13(id);
                }
            })
                .catch(() => this.setData13(id))
            : Promise.resolve(null);
    }
    deleteData1() {
        const id = constants_1.Constants.lsMapObject._data1;
        return new Promise((resolve) => {
            // if (this.check(id)) {
            localStorage.removeItem(id);
            // }
            resolve({ message: "ok" });
        });
    }
    deleteData2() {
        const id = constants_1.Constants.lsMapObject._data2;
        return new Promise((resolve) => {
            // if (this.check(id)) {
            localStorage.removeItem(id);
            // }
            resolve({ message: "ok" });
        });
    }
    deleteData3() {
        return __awaiter(this, void 0, void 0, function* () {
            const id = constants_1.Constants.lsMapObject._data3;
            try {
                yield nodejs_library_1.Helpers.SessionHelper.deleteData(id);
                return { message: "ok" };
            }
            catch (exception) {
                console.error("Errore delete data:", exception);
                return undefined;
            }
        });
    }
    setPreventivatoreAuto(param, isAuto) {
        let id;
        isAuto ? (id = constants_1.Constants.publicLsMap[0]) : (id = constants_1.Constants.publicLsMap[1]);
        return new Promise((resolve) => {
            // if (this.check(id)) {
            localStorage.removeItem(id);
            // }
            this.saveData(id, param, true);
            resolve({ message: "ok" });
        });
    }
    getPreventivo() {
        let allData;
        const numberType = 0;
        return new Promise((resolve) => {
            this.getAllPrev([], numberType)
                .then((response) => {
                if (response.length > 0) {
                    resolve(response);
                }
                else {
                    resolve(null);
                }
            })
                .catch((err) => console.error(err));
        });
    }
    setPreventivo(dataPrev) {
        const id = constants_1.Constants.quoteLsMap[dataPrev.typeByNumber];
        return new Promise((resolve) => {
            this.saveData(id, dataPrev, true);
            resolve(dataPrev);
        });
    }
    // SVUOTA IL LOCALSTORAGE
    clearLsl() {
        return __awaiter(this, void 0, void 0, function* () {
            yield nodejs_library_1.Helpers.SessionHelper.deleteAllData();
            localStorage.clear();
        });
    }
    // ------------------------------------FUNZIONI DI SOSTEGNO------------------------------------//
    // Per ogni valore dell'array quoteLsMap, cerca il relativo oggetto nel ls e lo inserisce in un array.
    getAllPrev(allData, numberType) {
        const id = constants_1.Constants.quoteLsMap[numberType];
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(id)
                .then((res) => {
                if (res) {
                    return this.dataFromStorage(id, true)
                        .then((response) => {
                        response.typeByNumber = numberType;
                        allData.push(response);
                        if (constants_1.Constants.quoteLsMap.length > Number(numberType) + 1) {
                            return this.getAllPrev(allData, Number(numberType) + 1)
                                .then((data) => {
                                allData = data;
                                return Promise.resolve(allData);
                            })
                                .catch((err) => console.error(err));
                        }
                        else {
                            return Promise.resolve(allData);
                        }
                    })
                        .catch((err) => console.error(err));
                }
                else {
                    if (constants_1.Constants.quoteLsMap.length > Number(numberType) + 1) {
                        return this.getAllPrev(allData, Number(numberType) + 1)
                            .then((data) => {
                            allData = data;
                            return Promise.resolve(allData);
                        })
                            .catch((err) => console.error(err));
                    }
                    else {
                        return Promise.resolve(allData);
                    }
                }
            })
                .catch(() => {
                if (constants_1.Constants.quoteLsMap.length > Number(numberType) + 1) {
                    return this.getAllPrev(allData, Number(numberType) + 1)
                        .then((data) => {
                        allData = data;
                        return Promise.resolve(allData);
                    })
                        .catch((err) => console.error(err));
                }
                else {
                    return Promise.resolve(allData);
                }
            })
            : Promise.resolve(null);
    }
    // SALVA I DATI, CON CONTROLLO SE ABILITATO IL SERVIZIO DI CRIPTAZIONE
    saveData(id, response, notEncrypted, options) {
        if (nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()) {
            const shouldStringify = !(options && options.notStringify);
            if (notEncrypted) {
                void nodejs_library_1.Helpers.SessionHelper.setData(id, shouldStringify ? JSON.stringify(response) : response);
            }
            else if (this.encryptionServiceEnabled) {
                Encryption_service_1.EncryptionService.encrypt(id, shouldStringify ? JSON.stringify(response) : response);
            }
            else {
                void nodejs_library_1.Helpers.SessionHelper.setData(id, shouldStringify ? JSON.stringify(response) : response);
            }
        }
    }
    // SETTO LE AGENZIE DELL'UTENTE
    setData0(id) {
        return new Promise((resolve) => {
            const tpdAgencyBFFService = new TpdAgency_service_1.TpdAgencyService();
            tpdAgencyBFFService.getElencoAgenzie().then((agenciesResponse) => {
                console.log(agenciesResponse);
                this.saveData(id, agenciesResponse);
                resolve(agenciesResponse);
            }, (error) => {
                resolve(error);
            });
        });
    }
    // SETTO LA getUserCtx()
    setData1UCC(id, fromTelematicHomepage, login) {
        return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
            const isSuperUserLogged = yield nodejs_library_1.Helpers.SessionHelper.getData("isSuperUserLogged");
            const personification = yield nodejs_library_1.Helpers.SessionHelper.getData("_impersonification");
            if (isSuperUserLogged !== undefined && isSuperUserLogged === true && (personification === undefined || personification === false)) {
                resolve(-1);
            }
            const userInfoService = new UserInfo_service_1.UserInfoService();
            userInfoService
                .getUserCtx(login)
                .then((userCtxResponse) => {
                var _a;
                if (userCtxResponse &&
                    (userCtxResponse.customer ||
                        constants_1.Constants.typePersona.personaGiuridica ===
                            ((_a = userCtxResponse.registry) === null || _a === void 0 ? void 0 : _a.type)) &&
                    userCtxResponse.policies &&
                    userCtxResponse.registry &&
                    userCtxResponse.username) {
                    //inserisco il timestamp per la verifica della cache
                    userCtxResponse["ts"] = new Date().getTime();
                    if (userCtxResponse.registry.type &&
                        typeof document === "object") {
                        document.cookie =
                            constants_1.Constants.TYPE_PERSONA_COOKIE +
                                "=" +
                                userCtxResponse.registry.type +
                                "; path=/";
                    }
                    // QUI AGGIUNGO ALLA getUserCtx I DATI DELLE POLIZZE TELEMATICHE
                    let policyLength = 0;
                    if (userCtxResponse &&
                        userCtxResponse.policies &&
                        userCtxResponse.policies.length) {
                        policyLength = userCtxResponse.policies.length;
                    }
                    if (policyLength > 0) {
                        let abilitaChiamate;
                        if (network_config_1.CONFIG.READ_CONFIG_FROM_SERVER ||
                            (!network_config_1.CONFIG.READ_CONFIG_FROM_SERVER && network_config_1.CONFIG.MOCK)) {
                            abilitaChiamate = true;
                        }
                        else {
                            fromTelematicHomepage == "fromTelematicHomepage"
                                ? (abilitaChiamate = true)
                                : (abilitaChiamate = false);
                        }
                        if (this.isTelematicsAble && abilitaChiamate) {
                            resolve(this.addTelematicContractsUCC(id, userCtxResponse));
                        }
                        else {
                            this.saveData(id, userCtxResponse);
                            resolve(userCtxResponse);
                        }
                    }
                    else {
                        console.log("No polizze");
                        this.saveData(id, userCtxResponse);
                        resolve(userCtxResponse);
                    }
                }
                else {
                    console.log("Caso wait_pg, response undefined");
                    resolve(-1);
                }
            }, (error) => {
                resolve(-1);
                if (this.isErrorCollectorEnabled) {
                    // tslint:disable-next-line: no-string-literal
                    if (typeof window === "object")
                        nodejs_library_1.Helpers.RouterHelper.goTo(window["ErrorEscape"] ? window["ErrorEscape"] : "/", {
                            openNewTab: false,
                        });
                }
                // this.tpdErrorsService.redirectFromError();
            })
                .catch((problem) => {
                resolve(-1);
            });
        }));
    }
    addTelematicContractsUCC(id, userCtxResponse) {
        return new Promise((resolve) => {
            if (userCtxResponse.allTelematicContracts) {
                const allContracts = userCtxResponse.allTelematicContracts;
                const obj = {
                    home: [],
                    auto: [],
                    building: [],
                    factory: [],
                    condominio: [],
                    albergo: [],
                };
                if (allContracts &&
                    allContracts.auto &&
                    allContracts.auto.contracts &&
                    allContracts.auto.contracts.length > 0) {
                    obj.auto = allContracts.auto.contracts;
                }
                if (allContracts &&
                    allContracts.buildings &&
                    allContracts.buildings.contracts &&
                    allContracts.buildings.contracts.length > 0) {
                    const casa = [];
                    const commercio = [];
                    const impresa = [];
                    const condominio = [];
                    const albergo = [];
                    for (const contract of allContracts.buildings.contracts) {
                        switch (contract.insuranceContractType) {
                            case "BOXHOM":
                                casa.push(contract);
                                obj.home = casa;
                                break;
                            case "BOXCOM":
                                commercio.push(contract);
                                obj.building = commercio;
                                break;
                            case "BOXIMP":
                                impresa.push(contract);
                                obj.factory = impresa;
                                break;
                            case "BOXCON":
                                condominio.push(contract);
                                obj.condominio = condominio;
                                break;
                            case "BOXALB":
                                albergo.push(contract);
                                obj.albergo = albergo;
                                break;
                        }
                    }
                }
                userCtxResponse.allTelematicContracts = obj;
                // SALVO LA USERCONTEXT ARRICCHITA CON LE INFORMAZIONI DEI CONTRATTI TELEMATICI
                this.saveData(id, userCtxResponse);
                resolve(userCtxResponse);
            }
            else {
                this.saveData(id, userCtxResponse);
                resolve(userCtxResponse);
            }
        });
    }
    // SETTO LA getVASInformations()
    setData2(id, vehiclePlate) {
        const objectCrashResport = {
            serviceName: "crashReport",
            isServiceEnabled: true,
            isServiceActivated: true,
            serviceRequiredCredits: false,
            rechargeOwnership: "Unipol",
            serviceAvailableCredits: 0,
            serviceCreditUsed: 0,
        };
        const defaultResponse = {
            vehicleVAS: [objectCrashResport],
            operationResult: {
                type: 0,
                code: "",
                message: "",
            },
        };
        return new Promise((resolve) => {
            if (vehiclePlate) {
                vehiclePlate = vehiclePlate.replace(/ /g, "");
                // Aggiunto getData1 per verificare se posso o meno aggiungere "Percorrenza" per SmartDrive
                this.getData1("fromTelematicHomepage")
                    .then((userInfoResponse) => {
                    if (userInfoResponse) {
                        // recupero se è smart Drive
                        let byPassPercorrenzaSmartDrive = false;
                        for (const policy of userInfoResponse.policies) {
                            if (policy.numberPlate === vehiclePlate &&
                                policy.flagSmartDrive) {
                                byPassPercorrenzaSmartDrive = true;
                            }
                        }
                        // versione as-is...
                        const telematics = new TpdTelematics_service_1.TpdTelematicsService();
                        telematics.telematicContract
                            .vehicleVAS(vehiclePlate)
                            .then((response) => {
                            if (response && response.vehicleVAS) {
                                response.vehicleVAS.push(objectCrashResport);
                                // In caso sia una smartDrive devo aggiungere l'oggetto a mano in quanto il servizio non lo abilita di default
                                if (byPassPercorrenzaSmartDrive) {
                                    response.vehicleVAS.push({
                                        serviceName: "rangeStatistics",
                                        isServiceEnabled: true,
                                        isServiceActivated: true,
                                        serviceRequiredCredits: false,
                                        rechargeOwnership: "Unipol",
                                        serviceAvailableCredits: 0,
                                        serviceCreditUsed: 0,
                                    });
                                }
                            }
                            this.saveData(id, response);
                            resolve(response);
                        }, (error) => {
                            resolve(defaultResponse);
                        })
                            .then((reason) => {
                            resolve(defaultResponse);
                        })
                            .catch((err) => console.error(err));
                    }
                })
                    .catch((err) => console.error(err));
            }
            else {
                resolve(defaultResponse);
            }
        });
    }
    // SETTO le scelte dell'utente
    setData3(id, typeOfSelection, parameters) {
        const obj = {
            policyDetail: {
                agreementKey: "",
                agreementSystem: "",
                policyNumber: "",
                vehicleType: "",
                vehicleBrand: "",
                contractorRole: "",
                dataScadenzaPolizza: "",
                dettaglioGaranziePropostaRinnovo: {
                    tipoCarico: "",
                    tipologiaVariazione: "",
                },
                polizzaArricchitaConInfoPega: {},
            },
            telematicSelection: {
                plate: "",
                userSelection: "",
                serviceEnabled: "",
                creditRecharge: {
                    section: "",
                    status: 0,
                },
                telematicIdentifier: "",
            },
            complaintSelection: {
                publicid: null,
                stato: null,
                step: null,
                plate: null,
                policy: {},
                firstConfirm: null,
                cardPassivo: {
                    cardPassivoAbilitato: false,
                    tipoDenunciaCardPassivo: "",
                    publicIdSinistro: "",
                    dataOraSinistro: null,
                    luogoSinistro: {
                        indirizzo: "",
                        latitudine: 0,
                        longitudine: 0,
                    },
                    targaCTP: "",
                    modelloNS: "",
                    claimNumber: "",
                },
                denunciaSinistriRequest: {},
                caiDigitale: null,
            },
            pasAssistance: {
                plate: "",
                phoneNumber: "",
                helpRequestId: "",
            },
            loyalty: {
                idBuono: "",
                codiceAgenzia: "",
                nomeAgenzia: "",
                puntiRiaccreditati: "",
            },
            urltologin: {
                url: "",
            },
            prenotazioneVisita: {
                idSinistro: "",
                idVisita: "",
                idStruttura: "",
                assignmentId: "",
                structure: "",
                previous: "",
                analyticsData: {
                    accident_id: "",
                    accident_state: "",
                    accident_plate: "",
                    accident_type: "",
                },
            },
            preventivo: {},
        };
        return new Promise((resolve) => {
            switch (typeOfSelection) {
                case 1: // VADO IN DETTAGLIO POLIZZA DA HOMEPAGE
                    obj.policyDetail.agreementKey = parameters[0];
                    obj.telematicSelection.plate = parameters[1];
                    obj.policyDetail.agreementSystem = parameters[2];
                    obj.policyDetail.contractorRole = parameters[3];
                    obj.policyDetail.dataScadenzaPolizza = parameters[4];
                    obj.policyDetail.dettaglioGaranziePropostaRinnovo = parameters[5];
                    obj.policyDetail.polizzaArricchitaConInfoPega = parameters[6];
                    obj.policyDetail.division = parameters[6].division;
                    break;
                case 2: // VADO IN UNIBOX DA DETTAGLIO POLIZZA
                    obj.telematicSelection.plate = this.removeWitheSpaces(parameters[0]);
                    obj.policyDetail.vehicleType = parameters[1];
                    obj.policyDetail.vehicleBrand = parameters[2];
                    obj.policyDetail.agreementKey = parameters[3];
                    obj.policyDetail.agreementSystem = parameters[4];
                    break;
                case 3: // VADO IN UNIBOX SELEZIONANDO UN SERVIZIO TELEMATICO
                    obj.telematicSelection.plate = parameters[0];
                    obj.telematicSelection.userSelection = parameters[1];
                    obj.telematicSelection.serviceEnabled = parameters[2];
                    obj.policyDetail.agreementKey = parameters[3];
                    obj.policyDetail.agreementSystem = parameters[4];
                    obj.policyDetail.contractorRole = parameters[5];
                    obj.policyDetail.division = parameters[6];
                    break;
                case 4: // VADO IN UNIBOX DALLA SELEZIONE VISUALIZZA DETTAGLI oppure SALVO LA TARGA PER ASSISTENZA PAS
                    obj.telematicSelection.plate = parameters[0];
                    obj.policyDetail.agreementKey = parameters[1];
                    obj.policyDetail.agreementSystem = parameters[2];
                    obj.policyDetail.contractorRole = parameters[3];
                    obj.policyDetail.division = parameters[4];
                    break;
                case 5: // UTILIZZO LA FUNZIONE RICARICA CREDITI IN BODYGUARD O INFOVIAGGIO
                    obj.telematicSelection.creditRecharge.section = parameters[0];
                    obj.telematicSelection.creditRecharge.status = parameters[1];
                    break;
                case 6: // NAVIGAZIONE PREAPERTURA DENUNCIA
                    obj.complaintSelection.publicid = parameters[0];
                    obj.complaintSelection.stato = parameters[1];
                    obj.complaintSelection.step = parameters[2];
                    obj.complaintSelection.plate = parameters[3];
                    obj.complaintSelection.policy = parameters[4] || {};
                    obj.complaintSelection.firstConfirm = parameters[5];
                    obj.complaintSelection.cardPassivo = parameters[6];
                    obj.complaintSelection.denunciaSinistriRequest = parameters[7];
                    obj.complaintSelection.caiDigitale = parameters[8];
                    break;
                case 7: // PASSAGGIO A UNIBOX CASA-COMMERCIO/IMPRESA-SERVIZI DA HOMEPAGE E DA DETTAGLIO POLIZZA
                    obj.telematicSelection.telematicIdentifier = parameters[0];
                    break;
                case 8: // DA HOMEPAGE A PAGINA INSERIMENTO PIN
                    obj.policyDetail.policyNumber = parameters[0];
                    obj.policyDetail.agreementKey = parameters[1];
                    break;
                case 9: // DATI PER RICHIESTA PAS
                    obj.pasAssistance.plate = parameters[0];
                    obj.pasAssistance.phoneNumber = parameters[1];
                    obj.pasAssistance.helpRequestId = parameters[2];
                    break;
                case 10: // DATI PER LOYALTY
                    obj.loyalty.idBuono = parameters[0];
                    obj.loyalty.codiceAgenzia = parameters[1];
                    obj.loyalty.nomeAgenzia = parameters[2];
                    obj.loyalty.puntiRiaccreditati = parameters[3];
                    break;
                case 11: // URL DI LOGIN
                    obj.urltologin.url = parameters[0];
                    break;
                case 12:
                    obj.prenotazioneVisita.idSinistro = parameters[0];
                    obj.prenotazioneVisita.idVisita = parameters[1];
                    obj.prenotazioneVisita.idStruttura = parameters[2];
                    obj.prenotazioneVisita.assignmentId = parameters[3];
                    obj.prenotazioneVisita.structure = parameters[4];
                    obj.prenotazioneVisita.previous = parameters[5];
                    obj.prenotazioneVisita.analyticsData = parameters[6];
                    break;
                case 13:
                    obj.preventivo = parameters[0];
                    break;
            }
            this.saveData(id, obj);
            resolve(obj);
        });
    }
    modifyData(objectLocalStorageIndex, value) {
        const id = constants_1.Constants.lsMap[objectLocalStorageIndex];
        return new Promise((resolve) => {
            this.saveData(id, value);
            resolve(value);
        });
    }
    checkIfUnibox(plateOrContractId, policyAuto) {
        // let isUnibox = false;
        const uniboxObj = { isUnibox: false, telematicIdentifier: null };
        return new Promise((resolve) => {
            this.getData1()
                .then((userCtx) => {
                const allTelematics = (userCtx === null || userCtx === void 0 ? void 0 : userCtx.allTelematicContracts)
                    ? userCtx === null || userCtx === void 0 ? void 0 : userCtx.allTelematicContracts
                    : { auto: "" };
                if (policyAuto == "auto" && allTelematics.auto) {
                    const telematicPoliciesAuto = allTelematics.auto;
                    if (plateOrContractId && plateOrContractId != "") {
                        if (telematicPoliciesAuto) {
                            for (let b = 0; b < telematicPoliciesAuto.length; b++) {
                                const singleTelematicPolicy = telematicPoliciesAuto[b];
                                if (singleTelematicPolicy &&
                                    singleTelematicPolicy.vehicle &&
                                    singleTelematicPolicy.vehicle.plate) {
                                    if (plateOrContractId
                                        .toLowerCase()
                                        .trim()
                                        .replace(/\s+/g, "") ==
                                        singleTelematicPolicy.vehicle.plate
                                            .toLowerCase()
                                            .trim()
                                            .replace(/\s+/g, "")) {
                                        uniboxObj.isUnibox = true;
                                        uniboxObj.telematicIdentifier = plateOrContractId
                                            .toLowerCase()
                                            .trim()
                                            .replace(/\s+/g, "");
                                    }
                                }
                            }
                        }
                    }
                }
                else if (policyAuto != "auto") {
                    /* for (let telematicContractObj in userCtx.allTelematicContracts) {
                                if (telematicContractObj && userCtx.allTelematicContracts[telematicContractObj]) {
                                    for (let telematicContract of userCtx.allTelematicContracts[telematicContractObj]) {
                                        if (telematicContract && telematicContract.archiveNumber && telematicContract.archiveNumber.indexOf(plateOrContractId) > -1) { */
                    uniboxObj.isUnibox = true;
                    uniboxObj.telematicIdentifier = plateOrContractId; // telematicContract.telematicIdentifier;
                    /* break;
                        } else {
                            console.log("errore: nessun contratto telematico associato a questa polizza");
                        }
                    }
                }
            } */
                }
                else {
                    console.log("errore: nessun contratto telematico associato a questa polizza");
                }
                resolve(uniboxObj);
            })
                .catch((reason) => {
                console.warn(reason);
                resolve(uniboxObj);
            });
        });
    }
    removeWitheSpaces(x) {
        return x.replace(/\s+/g, "");
    }
    getData10() {
        const id = constants_1.Constants.lsMapObject._data10;
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(id)
                .then((val) => {
                if (val && this.isLocalStorageEnabled) {
                    return this.dataFromStorage(id);
                }
                else {
                    return Promise.resolve(null);
                }
            })
                .catch(() => Promise.resolve(null))
            : Promise.resolve(null);
    }
    getData10String() {
        const id = constants_1.Constants.lsMapObject._data10;
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(id)
                .then((val) => {
                if (val && this.isLocalStorageEnabled) {
                    return this.dataFromStorage(id, undefined, {
                        notParse: true,
                    });
                }
                else {
                    return Promise.resolve(null);
                }
            })
                .catch(() => Promise.resolve(null))
            : Promise.resolve(null);
    }
    setData10(data) {
        const id = constants_1.Constants.lsMapObject._data10;
        try {
            this.saveData(id, data, undefined, {
                notStringify: true,
            });
            return Promise.resolve(true);
        }
        catch (e) {
            return Promise.reject(e);
        }
    }
    // SETTO LA getOfferte()
    setData11(id, numQuote, numPrev, num) {
        return new Promise((resolve, reject) => {
            const tpdContrattiService = new TpdContratti_service_1.TpdContrattiService();
            tpdContrattiService.preventivi
                .getOfferte(numQuote, numPrev, num)
                .then((response) => {
                console.log(response);
                //Impedisco che venga salvato nel localstorage perchè i preventivi vengono modificati spesso
                /* const savedData: { response: GetOfferteResponse, ts: number } = {
                          ts: (new Date).getTime(),
                          response
                      };
                      this.saveData(id, savedData); */
                resolve(response);
            })
                .catch((problem) => {
                reject(problem);
            });
        });
    }
    // SETTO LA getClaimsList()
    setData12(id) {
        return new Promise((resolve, reject) => {
            const liquido = new Liquido_service_1.LiquidoService();
            liquido
                .getClaimsList()
                .then((response) => {
                const savedData = {
                    ts: new Date().getTime(),
                    response,
                };
                this.saveData(id, savedData);
                resolve(response);
            })
                .catch((problem) => {
                reject(problem);
            });
        });
    }
    // SETTO LA getClaimsList()
    setData13(id) {
        return new Promise((resolve, reject) => {
            const loyaltyService = new LoyaltyLite_service_1.LoyaltyLiteService();
            loyaltyService
                .getSaldoPuntiVerificaAdesione(true)
                .then((response) => {
                const savedData = {
                    ts: new Date().getTime(),
                    response,
                };
                this.saveData(id, savedData);
                resolve(response);
            })
                .catch((problem) => {
                const savedData = {
                    ts: new Date().getTime(),
                    response: problem,
                };
                this.saveData(id, savedData);
                reject(problem);
            });
        });
    }
    getData14() {
        const id = constants_1.Constants.lsMapObject._data14;
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(id)
                .then((val) => {
                if (val) {
                    return this.dataFromStorage(id).then((data) => {
                        if (data) {
                            return data;
                        }
                        else {
                            return this.setData14();
                        }
                    });
                }
                else {
                    return this.setData14();
                }
            })
                .catch(() => this.setData14())
            : Promise.resolve(null);
    }
    setData14() {
        const id = constants_1.Constants.lsMapObject._data14;
        return new Promise((resolve, reject) => {
            const tpdContestoUtente = new TpdContestoUtente_service_1.TpdContestoUtenteService();
            tpdContestoUtente.cliente().then((res) => {
                const savedData = {
                    ts: new Date().getTime(),
                    response: res,
                };
                this.saveData(id, savedData);
                resolve(res);
            }).catch((e) => {
                const savedData = {
                    ts: new Date().getTime(),
                    response: null,
                };
                this.saveData(id, savedData);
                reject(null);
            });
        });
    }
    setData17(data17) {
        const id = constants_1.Constants.lsMapObject._data17;
        this.saveData(id, data17);
    }
    getData17() {
        const id = constants_1.Constants.lsMapObject._data17;
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(id)
                .then((val) => {
                if (val && this.isLocalStorageEnabled) {
                    return this.dataFromStorage(id);
                }
                else {
                    return Promise.resolve(null);
                }
            })
                .catch(() => Promise.resolve(null))
            : Promise.resolve(null);
    }
    setData15(data15) {
        const id = constants_1.Constants.lsMapObject._data15;
        this.saveData(id, data15);
    }
    getData15() {
        const id = constants_1.Constants.lsMapObject._data15;
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(id)
                .then((val) => {
                if (val && this.isLocalStorageEnabled) {
                    return this.dataFromStorage(id);
                }
                else {
                    return Promise.resolve(null);
                }
            })
                .catch(() => Promise.resolve(null))
            : Promise.resolve(null);
    }
    setData16(data16) {
        const id = constants_1.Constants.lsMapObject._data16;
        this.saveData(id, data16);
    }
    getData16() {
        const id = constants_1.Constants.lsMapObject._data16;
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(id)
                .then((val) => {
                if (val && this.isLocalStorageEnabled) {
                    return this.dataFromStorage(id);
                }
                else {
                    return Promise.resolve(null);
                }
            })
                .catch(() => Promise.resolve(null))
            : Promise.resolve(null);
    }
    setDataPagamentoRicorrente(data17) {
        const id = constants_1.Constants.lsMapObject.metodoPagamentoRicorrente;
        this.saveData(id, data17);
    }
    getDataPagamentoRicorrente() {
        const id = constants_1.Constants.lsMapObject.metodoPagamentoRicorrente;
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(id)
                .then((val) => {
                if (val && this.isLocalStorageEnabled) {
                    return this.dataFromStorage(id);
                }
                else {
                    return Promise.resolve(null);
                }
            })
                .catch(() => Promise.resolve(null))
            : Promise.resolve(null);
    }
    isSuperUser() {
        return nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()
            ? nodejs_library_1.Helpers.SessionHelper.getData(constants_1.Constants.lsMapObject._data5).then((data5) => {
                if (data5) {
                    const jsonObject = JSON.parse(data5);
                    // tslint:disable-next-line: triple-equals
                    if (jsonObject.value0 == "0") {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            })
            : Promise.resolve(null);
    }
}
exports.LocalStorageLayer = LocalStorageLayer;
